import { schema, types } from 'papr'
const collectionName = 'userpublicationsubscriptions'

export const userPublicationSubscriptionSchema = schema(
	{
		user: types.objectId({ required: true }),
		publication: types.objectId({ required: true }),
		userLastVisitedDate: types.date(),
		lastPostPublishedDate: types.date(),
		unreadCount: types.number(),
		dateAdded: types.date(),
		recommendedByPublication: types.objectId(),
	},
	{
		defaults: {
			unreadCount: 0,
		},
	},
)

export const createUserPublicationSubscriptionIndex = async (db) => {
	await db.createIndex(collectionName, {
		lastPostPublishedDate: -1,
	})
	await db.createIndex(collectionName, {
		user: 1,
		lastPostPublishedDate: -1,
	})
	await db.createIndex(collectionName, {
		user: 1,
		dateAdded: -1,
	})
}

export type UserPublicationSubscriptionDocument = (typeof userPublicationSubscriptionSchema)[0]
export type UserPublicationSubscriptionDefaults = (typeof userPublicationSubscriptionSchema)[1]
